import { mockDatabase, mockComment } from '~/shared/mocking'
import { COMMENT_STATUS } from '~/modules/post/constants'

import {
  ERROR_GENERIC,
  ERROR_CHANNEL_DISCONNECTED,
  ERROR_SEND_COMMENT_DELETED,
  ERROR_SEND_PERMISSON,
} from '~/app/constants'

const TEXT_CHANNEL_DISCONNECTED = 'channel disconnected'
const TEXT_GENERIC_ERROR = 'generic error'
const TEXT_SEND_ERROR = 'send error'
const TEXT_PERMISSION_ERROR = 'permission error'

const DATA = mockDatabase()

// @ts-expect-error TS(7031) FIXME: Binding element 'socketId' implicitly has an 'any'... Remove this comment to see the full error message
const queryEngagePusherAuthentication = ({ socketId, pusherChannel }) => {
  return null
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'id' implicitly has an 'any' type.
const queryEngageChannel = ({ id }) => {
  return DATA.engageOrganization.channels.find((el) => el.id === id)
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'id' implicitly has an 'any' type.
const queryPost = ({ id }) => {
  return DATA.posts.find((el) => el.id === id)
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'postId' implicitly has an 'any' t... Remove this comment to see the full error message
const queryComment = ({ postId, commentId }) => {
  const post = queryPost({ id: postId })

  let parent = null
  let comment = null

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  for (const postComment of post.comments) {
    parent = postComment
    // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'never'.
    comment = postComment.id === commentId ? postComment : null

    if (!comment) {
      // @ts-expect-error TS(2339) FIXME: Property 'replies' does not exist on type 'never'.
      for (const reply of postComment.replies) {
        comment = reply.id === commentId ? reply : null

        if (comment) break
      }
    }

    if (comment) break
  }

  return {
    parent,
    comment,
  }
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'channelServiceId' implicitly has ... Remove this comment to see the full error message
const queryEngagePosts = ({ channelServiceId, filter, first, after }) => {
  const { value } = filter || {}

  const channelPosts = DATA.posts.filter((el) => {
    const labelFound = filter
      ? el.labelsCount.find(
          // @ts-expect-error TS(2339) FIXME: Property 'label' does not exist on type 'never'.
          (counter) => counter.label === value && counter.count > 0,
        )
      : true

    return el.channelServiceId === channelServiceId && labelFound
  })

  channelPosts.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )

  const startIndex = channelPosts.findIndex((el) => el.id === after) + 1
  const result = channelPosts.slice(startIndex, startIndex + first)
  const endCursor = result ? result[result.length - 1].id : null
  const hasNextPage =
    endCursor && endCursor !== channelPosts[channelPosts.length - 1].id

  return {
    edges: result.map((post) => {
      return {
        node: {
          typename: 'EngagePost',
          ...post,
        },
        cursor: post.id,
      }
    }),
    pageInfo: {
      endCursor,
      hasNextPage,
    },
  }
}

/**
 *
 */
const queryUserSettings = () => {
  return DATA.userSettings
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'organizationId' implicitly has an 'any'... Remove this comment to see the full error message
const queryEngageOrganization = (organizationId) => {
  return DATA.engageOrganization
}

/**
 *
 */
const queryAccount = () => {
  return DATA.account
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'type' implicitly has an 'any' typ... Remove this comment to see the full error message
const dismissAll = ({ type, targetId }) => {
  if (type !== 'post') {
    return
  }

  const post = queryPost({ id: targetId })
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  post.dismissingAll = true

  return {
    success: true,
    code: '',
  }
}

/**
 *
 */
const processComment = (
  operation = 'reply',
  // @ts-expect-error TS(7031) FIXME: Binding element 'postId' implicitly has an 'any' t... Remove this comment to see the full error message
  { postId, commentId, text = '' },
) => {
  let success = true
  let errorCode = null

  const post = queryPost({ id: postId })
  const { parent, comment } = queryComment({ postId, commentId })
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const engageChannel = queryEngageChannel({ id: post.channelServiceId })

  const error = {
    type: operation,
    draft: text,
  }

  if (!post || !engageChannel || !comment || text === TEXT_GENERIC_ERROR) {
    success = false
    errorCode = ERROR_GENERIC
  }

  if (text === TEXT_CHANNEL_DISCONNECTED) {
    success = false
    errorCode = ERROR_CHANNEL_DISCONNECTED
  }

  if (text === TEXT_PERMISSION_ERROR) {
    success = false
    errorCode = ERROR_SEND_PERMISSON
  }

  if (text === TEXT_SEND_ERROR) {
    success = false
    errorCode = ERROR_SEND_COMMENT_DELETED
  }

  const newReply = mockComment({
    replies: 0,
    override: {
      text,
      createdAt: Date.now(),
      from: {
        username: 'buffer',
        isChannel: true,
      },
      needsAttention: false,
      error: null,
      labels: [],
    },
  })

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  let updatedCounters = post.labelsCount

  if (success) {
    // Update comment.
    comment.needsAttention = false
    if (operation === 'reply') {
      comment.status = COMMENT_STATUS.REPLIED
      comment.replies.push(newReply)
    } else {
      comment.status = COMMENT_STATUS.DISMISSED
    }

    // Update post.
    const labels = comment.labels

    if (labels.length) {
      // @ts-expect-error TS(2322) FIXME: Type '{ __typename: string; label: never; count: n... Remove this comment to see the full error message
      updatedCounters = post.labelsCount.map(({ label, count }) => ({
        __typename: 'LabelCount',
        label,
        count: labels.includes(label) ? count - 1 : count,
      }))
    }

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    post.labelsCount = updatedCounters
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    post.totalPendingComments--
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    post.commentsUpdatedAt = new Date().toISOString()

    // Update channel.
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    engageChannel.totalPendingComments--
  }

  comment.error =
    errorCode && errorCode !== ERROR_CHANNEL_DISCONNECTED
      ? {
          ...error,
          code: errorCode,
        }
      : null

  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  const isParent = parent.id === comment.id

  return {
    __typename: 'EngagementMutationResponse',
    success,
    message: '',
    code: errorCode,
    post: {
      __typename: 'EngagePost',
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      id: post.id,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalPendingComments: post.totalPendingComments,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalComments: post.totalComments,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      labelsCount: success ? updatedCounters : post.labelsCount,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      commentsUpdatedAt: post.commentsUpdatedAt,
    },
    comment: {
      __typename: 'Comment',
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      id: parent.id,
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      needsAttention: parent.needsAttention,
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      status: parent.status,
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      error: parent.error,
    },
    reply:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      comment.id !== parent.id
        ? {
            __typename: 'Reply',
            id: comment.id,
            needsAttention: comment.needsAttention,
            status: comment.status,
            error: comment.error,
          }
        : null,
    replySent:
      success && operation === 'reply'
        ? {
            __typename: 'Reply',
            ...newReply,
          }
        : null,
    channel: {
      __typename: 'EngageChannel',
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      id: engageChannel.id,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalPendingComments: engageChannel.totalPendingComments,
    },
  }
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'postId' implicitly has an 'any' t... Remove this comment to see the full error message
const unprocessComment = ({ postId, commentId, text = '' }) => {
  const post = queryPost({ id: postId })
  const { parent, comment } = queryComment({ postId, commentId })
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const engageChannel = queryEngageChannel({ id: post.channelServiceId })

  // Update comment.
  comment.needsAttention = true
  comment.status = COMMENT_STATUS.PENDING

  // Update post.
  const labels = comment.labels
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  let updatedCounters = post.labelsCount

  if (labels.length) {
    // @ts-expect-error TS(2322) FIXME: Type '{ __typename: string; label: never; count: n... Remove this comment to see the full error message
    updatedCounters = post.labelsCount.map(({ label, count }) => ({
      __typename: 'LabelCount',
      label,
      count: labels.includes(label) ? count + 1 : count,
    }))
  }

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  post.labelsCount = updatedCounters
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  post.totalPendingComments++
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  post.commentsUpdatedAt = new Date().toISOString()

  // Update channel.
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  engageChannel.totalPendingComments++

  return {
    __typename: 'EngagementMutationResponse',
    success: true,
    code: '',
    message: '',
    post: {
      __typename: 'EngagePost',
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      id: post.id,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalPendingComments: post.totalPendingComments,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalComments: post.totalComments,
      labelsCount: updatedCounters,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      commentsUpdatedAt: post.commentsUpdatedAt,
    },
    comment: {
      __typename: 'Comment',
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      id: parent.id,
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      needsAttention: parent.needsAttention,
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      status: parent.status,
      error: null,
    },
    reply:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      comment.id !== parent.id
        ? {
            __typename: 'Reply',
            id: comment.id,
            needsAttention: comment.needsAttention,
            status: comment.status,
            error: null,
          }
        : null,
    replySent: null,
    channel: {
      __typename: 'EngageChannel',
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      id: engageChannel.id,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      totalPendingComments: engageChannel.totalPendingComments,
    },
  }
}

/**
 *
 */
const hideMarkAsReadModal = () => ({
  success: true,
  code: '',
  message: '',
})

/// //////////////////////////////////////////////////
// Resolvers
/// //////////////////////////////////////////////////

export default {
  Query: () => ({
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    account: (_, variables) => queryAccount(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageOrganization: (_, variables) => queryEngageOrganization(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engagePost: (_, variables) => queryPost(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engagePosts: (_, variables) => queryEngagePosts(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageUserSettings: (_, variables) => queryUserSettings(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engagePusherAuthentication: (_, variables) =>
      queryEngagePusherAuthentication(variables),
  }),

  Mutation: () => ({
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageReply: (_, variables) => processComment('reply', variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageDismiss: (_, variables) => processComment('dismiss', variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageDismissAll: (_, variables) => dismissAll(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageUnDismiss: (_, variables) => unprocessComment(variables),
    // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    engageHideMarkAsReadModal: (_, variables) => hideMarkAsReadModal(variables),
  }),
}
